<form clrForm
      *ngIf="positions.length > 0"
      [formGroup]="editDeliveryForm">
  <table class="table" id="positionsTable">
    <thead>
    <tr>
      <th class="left">Position</th>
      <th class="left">Komponente</th>
      <th class="left">Zeichnung</th>
      <th class="left">Material</th>
      <th>Anzahl</th>
      <th>Preis in EUR</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td>{{ editPosition }}<span *ngIf="editPart !== 0">.{{ editPart }}</span></td>
      <td class="left">
        {{ positions[0].name }}
        <span *ngIf="positions[0].description"><br />{{ positions[0].description }}</span>
      </td>
      <td class="left">{{ positions[0].technical_drawing }}</td>
      <td class="left">{{ positions[0].material }}</td>
      <td><input type="text" formControlName="number_of_pieces" class="clr-input"></td>
      <td><input type="text" formControlName="selling_price" class="clr-input"></td>
      <td rowspan="3" class="btn-group btn-primary btn-icon">
        <button class="btn btn-sm" (click)="updateDeliveryPosition()" [disabled]="editDeliveryForm.invalid">
          <cds-icon shape="floppy"></cds-icon>
          <span class="clr-icon-title">Speichern</span>
        </button>
      </td>
    </tr>
    <tr *ngIf="positions[0].specification">
      <td colspan="3"></td>
      <td colspan="3" class="left"><b>Spezifikation:</b> {{ positions[0].specification }}</td>
    </tr>
    <tr>
      <td colspan="3"></td>
      <td colspan="3" class="left">
        <div class="clr-form-control">
          <label for="serial_nr" class="clr-control-label">Kennzeichnung</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              <input formControlName="serial_nr" id="serial_nr" class="clr-input">
              <cds-icon class="clr-validate-icon" shape="exclamation-circle"></cds-icon>
            </div>
          </div>
        </div>
        <div class="clr-form-control">
          <label for="heat_nr" class="clr-control-label">Chargen-Nr.</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              <input formControlName="heat_nr" id="heat_nr" class="clr-input">
              <cds-icon class="clr-validate-icon" shape="exclamation-circle"></cds-icon>
            </div>
          </div>
        </div>
        <div class="clr-form-control">
          <label for="controlling_nr" class="clr-control-label">Kostenstelle</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              <input formControlName="controlling_nr" id="controlling_nr" class="clr-input">
              <cds-icon class="clr-validate-icon" shape="exclamation-circle"></cds-icon>
            </div>
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="3"></td>
      <td colspan="3" class="left">
        <div class="clr-form-control">
          <label for="comment_phm" class="clr-control-label">Kommentar</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              <textarea formControlName="comment_phm" id="comment_phm" cols="100" rows="6" class="clr-textarea"></textarea>
              <cds-icon class="clr-validate-icon" shape="exclamation-circle"></cds-icon>
            </div>
            <span class="clr-subtext">Dieser Kommentar ist intern.</span>
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="3"></td>
      <td colspan="3" class="left">
        <div class="clr-form-control">
          <label for="remarks" class="clr-control-label">Leistungsumfang</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              <textarea formControlName="remarks" id="remarks" cols="100" rows="6" class="clr-textarea"></textarea>
              <cds-icon class="clr-validate-icon" shape="exclamation-circle"></cds-icon>
            </div>
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="3"></td>
      <td colspan="3" class="left">
        <div class="clr-form-control">
          <label for="side_agreements" class="clr-control-label">Nebenabreden mit dem Kunden</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              <textarea formControlName="side_agreements" id="side_agreements" cols="100" rows="6" class="clr-textarea"></textarea>
              <cds-icon class="clr-validate-icon" shape="exclamation-circle"></cds-icon>
            </div>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</form>
